export const SET_DROPSHIP_FLAG = 'SET_DROPSHIP_FLAG';

const initialState = {
  isDropship: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DROPSHIP_FLAG: {
      return {
        ...state,
        isDropship: action.data !== 'N',
      };
    }
    default:
      return state;
  }
};

export const setIsDropship = data => ({
  type: SET_DROPSHIP_FLAG,
  data,
});

